import { Controller } from "@hotwired/stimulus"

// Displays the appropriate keyboard shortcut based on platform (⌘ for Mac, Ctrl for others)
export default class extends Controller {
  static targets = ["key", "srLabel"]
  static values = {
    mac: { type: String, default: "⌘" },
    other: { type: String, default: "Ctrl" }
  }

  connect() {
    this.updateKey()
  }

  action(){
    this.element.click();
  }

  updateKey() {
    const isMac = /mac|iphone|ipad|ipod/i.test(navigator.platform)
    const key = isMac ? this.macValue : this.otherValue
    
    if (this.hasKeyTarget) {
      this.keyTarget.textContent = key
    }
    
    if (this.hasSrLabelTarget) {
      const keyName = isMac ? 'Command' : 'Control'
      const currentText = this.srLabelTarget.textContent
      // Replace placeholder if it exists
      this.srLabelTarget.textContent = currentText.replace(/\{key\}/g, keyName)
    }
  }
}
